<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Upload de Arquivos</p>
    </div>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="unidade" label="Regras por Unidade" />
      <q-tab name="centro" label="Regras por Centro de Custo" />
      <q-tab name="funcao" label="Regras por Função" />
      <q-tab name="individual" label="Regras Individuais" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="unidade">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras por Unidade
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>

        <infot-upload
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/vendorxprodutos.xlsx'"
          :activeSlide="activeSlide"
          :infos="infos"
          :showUnidade="false"
        />

        <upload
          :mapeamento="'regra_por_vendor'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/vendorxprodutos.xlsx'"
          title="REGRAS POR UNIDADE - LEIA AS INTRUÇÕES COM ATENÇÃO"
        />
      </q-tab-panel>

      <q-tab-panel name="funcao">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras por Função
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide2 = !activeSlide2"
            />
          </p>
        </div>
        <infot-upload
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/funcaoXprodutos.xlsx'"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          :infos="infos"
        />
        <upload
          class="q-mt-md"
          :mapeamento="'regra_por_funcao'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/funcaoXprodutos.xlsx'"
          title="REGRAS POR FUNÇÃO / GHE - LEIA AS INTRUÇÕES COM ATENÇÃO"
          termo="função/ghe"
        />
      </q-tab-panel>

      <q-tab-panel name="centro">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras por Centro de Custo
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide3 = !activeSlide3"
            />
          </p>
        </div>
        <infot-upload
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/centroXprodutos.xlsx'"
          :activeSlide="activeSlide3"
          :showUnidade="false"
          :infos="infos"
        />
        <upload
          class="q-mt-md"
          :mapeamento="'regra_centro_custo'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/centroXprodutos.xlsx'"
          title="REGRAS POR CENTRO DE CUSTO - LEIA AS INTRUÇÕES COM ATENÇÃO"
          termo="cod centro de custo"
        />
      </q-tab-panel>
      <q-tab-panel name="individual">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Regras Individuais
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide4 = !activeSlide4"
            />
          </p>
        </div>
        <infot-upload
          :infos="infos"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/individualxprodutos_r1.xlsx'"
          :activeSlide="activeSlide4"
          :showUnidade="false"
        />
        <upload
          class="q-mt-md"
          :mapeamento="'regra_individual'"
          :link="'https://multpex-docs.s3.amazonaws.com/templates/upload-regras/individualxprodutos_r1.xlsx'"
          title="REGRAS INDIVIDUAIS - LEIA AS INTRUÇÕES COM ATENÇÃO"
          termo="user Id ou SAP#"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import Upload from "../components/UploadComponent.vue";
import { ref } from "@vue/reactivity";
import InfotUpload from "../../compras/components/InfotUpload.vue";
export default {
  components: { Upload, InfotUpload },
  setup() {
    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);
    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "TODOS OS CAMPOS SÃO OBRIGATÓRIOS",
        icon: "delete",
      },
      {
        name: " O termo digitado no campo ,deve ser IDÊNTICO aos códigos dos centros de custo criados no sistema.Caso não encontre refeência no sistema, a linha será ignorada.",
        icon: "view_column",
      },
      {
        name: "O termo referente a grupo de produto, digitado na coluna grupo_de_produto, deve ser IDÊNTICO ao criado no sistema, se o nome digitado não for encontrado, a importação irá ignorar a linha.",
        icon: "do_not_disturb",
      },
      {
        name: " Prazo mínimo e prazo máximo são fornecidos em DIAS, digite somente números.Não é aceito prazo 0",
        icon: "event",
      },
      {
        name: "A coluna quantidade deve ser preenchida com a quantidade esperada de uso no período definido. Este campo não pode ser 0.",
        icon: "event",
      },
      {
        name: "Tipo de controle é como você deseja monitorar as trocas dos usuários, sendo elas.",
        icon: "event",
      },
      {
        name: "Nenhum, Ambos, Farol, E-mail",
        icon: "event",
      },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      infos,
      tab: ref("unidade"),
    };
  },
};
</script>

<style></style>
